'use client';

import { useState } from 'react';

import { Button } from '@components/Form';
import { fetchApi } from '@utils/api/client';
import { useUserStore } from '@utils/user';

export default function DraftModeBar() {
  const [isDraftMode, setIsDraftMode] = useState(true);
  const [isImpersonatingPremium, setIsImpersonatingPremium] = useState(false);
  const [isDisablingDraftMode, setIsDisablingDraftMode] = useState(false);
  const userStore = useUserStore();

  const toggleImpersonatingPremium = () => {
    userStore.setPremiumOverride(!isImpersonatingPremium);
    setIsImpersonatingPremium(!isImpersonatingPremium);
  };

  const exitDraftMode = async () => {
    if (isDisablingDraftMode) {
      return;
    }

    setIsDisablingDraftMode(true);
    userStore.disablePremiumOverride();

    await fetchApi('/posts/disable-draft');

    setIsDraftMode(false);
  };

  if (!isDraftMode) return null;

  return (
    <div className="fixed bottom-6 z-[100] flex w-full items-center justify-center lg:bottom-40">
      <div className="max-w-[480px] flex-grow rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-lg lg:px-6 lg:py-3">
        <h6 className="mb-3 text-center text-lg font-bold text-premium-900">
          Draft Mode
        </h6>
        <div className="flex items-center justify-between gap-6 whitespace-nowrap">
          <div className="flex max-w-48 flex-1 items-center">
            <span className="mr-2">Viewing as:</span>
            <Button type="button" onClick={toggleImpersonatingPremium}>
              {isImpersonatingPremium ? 'Premium' : 'Free'}
            </Button>
          </div>
          <Button
            type="button"
            className="max-w-48 flex-1"
            loading={isDisablingDraftMode}
            disabled={isDisablingDraftMode}
            onClick={exitDraftMode}
          >
            Exit Draft
          </Button>
        </div>
      </div>
    </div>
  );
}
